module.exports = __webpack_public_path__ + "img/item-5.2418952.png";